import { LineItem } from '@printdeal/commercetools-v2/types';
import { isQuoteLineItem } from '@printdeal/business-logic';
import { ReOrderLineItemArtwork } from '@printdeal/checkout-shared';
import FileDelivery from '../services/file-delivery/FileDeliveryService';
// @ts-expect-error
import { getDocRefCopy, shouldSkipReview } from './ReorderLineItemBuilder';

const reOrderDuplicateArtworkHelper = async (
  lineItems: LineItem[],
  fileDeliveryApi: FileDelivery,
): Promise<ReOrderLineItemArtwork[]> => Promise.all(lineItems.filter((lineItem) =>
  !isQuoteLineItem(lineItem)
    && (lineItem.custom?.fields.mcpDocumentsSource
      || lineItem.custom?.fields.manufacturingReadyDocumentUrl))
  .map(async (lineItem) => ({
    lineItemId: lineItem.id,
    mcpDocumentsSource: lineItem.custom?.fields.mcpDocumentsSource
        && await getDocRefCopy(lineItem.custom.fields.mcpDocumentsSource, fileDeliveryApi),
    skipReview: shouldSkipReview(lineItem) ? 'REORDER_SAME_FILE' : undefined,
  })));

export {
  reOrderDuplicateArtworkHelper,
};
